export enum DeadModeEnum {
    Dead,
    Logs,
    Details,
}